export default __webpack_public_path__ + "static/media/2023_Chung_et_al_2023_JEcol.f0db44b3.pdf";